'use client';

import Image from 'next/image';

import { momentTimezone } from '@/utils/time';

import Button from './Button';

interface PointLoungeEarnListItemProps {
  title: string;
  image: string;
  point: number;
  startDttm: number;
  endDttm: number;
  isCompleted: boolean;
  onClick: () => void;
  buttonLabel: string;
  disabled: boolean;
  isLoading?: boolean;
}

export default function PointLoungeEarnListItem({
  title,
  image,
  startDttm,
  endDttm,
  isCompleted,
  onClick,
  buttonLabel,
  disabled,
  isLoading = false,
}: PointLoungeEarnListItemProps) {
  const imageSrcUrl = image?.startsWith('http')
    ? image
    : image
      ? `${process.env.NEXT_PUBLIC_CDN_URL}/${image}`
      : '/images/@/@img_404.svg';

  const formattedStartDate = momentTimezone(startDttm).format('YY.MM.DD');
  const formattedEndDate = momentTimezone(endDttm).format('YY.MM.DD');

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex w-full flex-row gap-4">
        {/* Image */}
        <div className={`h-[120px] w-[120px] shrink-0 rounded gradient-border ${isCompleted ? 'gradient-border-point-lounge-list-image-completed' : 'gradient-border-point-lounge-list-image'}`}>
          <div className="relative h-full w-full overflow-hidden rounded bg-point-lounge-list-image-bg">
            <Image src={imageSrcUrl} alt={title} fill style={{ objectFit: 'cover' }} />
            {isCompleted && (
              <div className="absolute inset-0 z-[1] flex items-center justify-center bg-point-lounge-list-completed-overlay">
                <span className="typo-body-4 text-white/70">참여완료</span>
              </div>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col justify-between gap-4">
          <div className="flex flex-col gap-2">
            <span className="typo-body-8 font-medium text-white">
              {formattedStartDate} ~ {formattedEndDate}
            </span>
            <h3 className="typo-body-1 font-bold text-white">{title}</h3>
          </div>
          <Button
            variant="secondary"
            className="self-start"
            onClick={onClick}
            disabled={disabled || isLoading}
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
